export enum SnackBarType {
    ERROR,
    WARNING,
    SUCCESS,
}